import { NavigateBefore } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers-pro";
import axios from "axios";
import { ErrorMessage, FormikProvider } from "formik";
import { enqueueSnackbar } from "notistack";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Delete from "../../../../components/app/delete/delete";
import PageMenu from "../../../../components/custom/app/pageMenu/pageMenu";
import PageContentWrapper from "../../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../../components/mui/app/pageTitle/pageTitle";
import CustomAutocomplete from "../../../../components/mui/form/autocomplete/autocomplete";
import Modal from "../../../../components/mui/general/modal/modal";
import { API } from "../../../../helpers/constants";
import { handleAxiosErrors } from "../../../../helpers/errorHandling";
import { formControlDefaults, numericFormatDefaults, textFieldDefaults } from "../../../../helpers/theme/defaultProps";
import useUserData from "../../../../hooks/user/useUserData";
import useProjectForm from "../../hooks/useProjectForm";
import { PROJECTS } from "../../locales/namespaces";

const Form = (props) => {
	const { projectId, project, assignees, projectWorks } = props
	const { t } = useTranslation(PROJECTS)
	const { formik, loadingSubmit } = useProjectForm(({ projectId, project, assignees, projectWorks }))
	const { dateFormat } = useUserData();
	const [users, setUsers] = useState(Object.values(assignees));
	
	const [isDeletionVisible, setIsDeletionVisible] = useState(false)
	
	const handleDeletionModal = (visible) => {
		setIsDeletionVisible(visible)
	}
	
	const handleDate = (newValue, name) => {
		const validDate = newValue !== 'Invalid date' ? newValue : null;
		formik.setFieldValue(name, validDate);
		
		const { StartDt, EndDt } = formik.values;
		
		if ((name === 'StartDt' && EndDt) || (name === 'EndDt' && StartDt)) {
			const start = name === 'StartDt' ? validDate : StartDt;
			const end = name === 'EndDt' ? validDate : EndDt;
			
			if (start && end && new Date(start) > new Date(end)) {
				enqueueSnackbar(t('Start date must be before the end date.'), {
					variant: 'warning',
					autoHideDuration: 3000
				});
			}
		}
	};
	
	const handleSearch = (evt, name) => {
		let setter
		let url
		switch (name) {
			case 'users':
				url = `${API}/en/users/search`
				setter = setUsers
				break
			default:
				break
		}
		if (evt.target.value.length >= 3) {
			axios({
				method: 'post',
				data: { 'query': evt.target.value },
				url: url
			}).then((response) => {
				setter(response.data.data)
			}).catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
			})
		}
	}
	return (
		<FormikProvider value={formik}>
			<form
				onSubmit={formik.handleSubmit}
				autoComplete="off"
				id="projectForm"
				encType="multipart/form-data"
				style={{ marginTop: '10px' }}
			>
				<Box display={'flex'}
					 flexWrap={'wrap'}
					 justifyContent={'space-between'}
					 gap={1}>
					<PageMenu>
						<Button
							component={Link}
							startIcon={<NavigateBefore/>}
							to={`/projects`}
						>
							{t('Return')}
						</Button>
						{projectId && (<Button
							component={Link}
							to={`/project/details/${projectId}`}
						>
							{t('Details')}
						</Button>)}
						<LoadingButton
							loading={loadingSubmit}
							type={'submit'}
							// onClick={formik.submitForm}
							variant="contained"
							startIcon={<SaveIcon/>}
						>
							{t('Save')}
						</LoadingButton>
					</PageMenu>
					{projectId && (
						// <PermissionHOC requiredPermissions={['view_all_users']}>
						<Button
							size={'small'}
							variant={'contained'}
							color={'error'}
							// onClick={onDelete}
							onClick={() => handleDeletionModal(true)}
						>
							{t('Delete')}
						</Button>
						// </PermissionHOC>
					)}
				</Box>
				<PageContentWrapper>
					<PageTitle
						withDivider
						title={!projectId ? t('Project Create') : t('Project Edit')}
					/>
					<Grid
						container
						spacing={2}
						sx={{ marginLeft: '0px' }}
					>
						
						<Grid size={{ xs: 4, sm: 6, md: 6 }}>
							<Grid size={{ xs: 12, sm: 12, md: 12 }}>
								<Box>
									<Grid container spacing={2}>
										<Grid size={{ md: 10 }}>
											<Grid>
												<FormControl
													{...formControlDefaults}
												>
													<FormLabel required>{t('Description')}</FormLabel>
													<TextField
														{...textFieldDefaults}
														name={'Description'}
														value={formik.values.Description}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
													/>
													<FormHelperText>
														<ErrorMessage name={'Description'}/>
													</FormHelperText>
												</FormControl>
											</Grid>
										</Grid>
										<Grid size={{ md: 2 }}>
											<Grid>
												<FormControl
													{...formControlDefaults}
												>
													<FormControlLabel
														control={
															<Checkbox
																checked={formik.values.isActive}
																onChange={formik.handleChange}
																name="isActive"
																onBlur={formik.handleBlur}
															/>
														}
														label={<FormLabel>{t('Active')}</FormLabel>}
													/>
												</FormControl>
											</Grid>
										</Grid>
										{/*<Grid*/}
										{/*	size={{md:12}}*/}
										{/*>*/}
										{/*	<FormControl*/}
										{/*		{...formControlDefaults}*/}
										{/*		error={*/}
										{/*			formik.touched['AssigneeId'] &&*/}
										{/*			Boolean(formik.errors['AssigneeId'])*/}
										{/*		}*/}
										{/*	>*/}
										{/*		<FormLabel required>{t('Foreman')}</FormLabel>*/}
										{/*		<CustomAutocomplete*/}
										{/*			identifier={'id'}*/}
										{/*			value={formik.values.AssigneeId}*/}
										{/*			// onChange={formik.handleChange}*/}
										{/*			onChange={(evt,newValue)=>formik.setFieldValue('AssigneeId', newValue)}*/}
										{/*			options={users}*/}
										{/*			labelKey={'Description'}*/}
										{/*			onInputChange={(event) => handleSearch(event, 'users')}*/}
										{/*			otherprops={{*/}
										{/*				handleHomeEndKeys: true*/}
										{/*			}}*/}
										{/*		/>*/}
										{/*		<FormHelperText>*/}
										{/*			<ErrorMessage name={'AssigneeId'}/>*/}
										{/*		</FormHelperText>*/}
										{/*	</FormControl>*/}
										{/*</Grid>*/}
										<Grid size={{ md: 5 }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['StartDt'] &&
													Boolean(formik.errors['StartDt'])
												}
											>
												<FormLabel required>{t('Start')}</FormLabel>
												<DatePicker
													slotProps={{
														textField: {
															size: 'small',
															variant: 'standard'
														}
													}}
													name="StartDt"
													views={['year', 'month', 'day']}
													inputFormat={'DD-MM-YYYY'}
													value={formik.values.StartDt}
													onChange={(newValue) => handleDate(newValue, 'StartDt')}
													onBlur={formik.handleBlur}
													format={dateFormat}
												/>
												<FormHelperText>
													<ErrorMessage name={'StartDt'}/>
												</FormHelperText>
											</FormControl>
										</Grid>
										<Grid size={{ md: 5 }}>
											<FormControl
												{...formControlDefaults}
												error={
													formik.touched['EndDt'] &&
													Boolean(formik.errors['EndDt'])
												}
											>
												<FormLabel>{t('End')}</FormLabel>
												<DatePicker
													slotProps={{
														textField: {
															size: 'small',
															variant: 'standard'
														}
													}}
													name="EndDt"
													views={['year', 'month', 'day']}
													inputFormat={'DD-MM-YYYY'}
													value={formik.values.EndDt}
													onChange={(newValue) => handleDate(newValue, 'EndDt')}
													onBlur={formik.handleBlur}
													format={dateFormat}
												/>
												<FormHelperText>
													<ErrorMessage name={'EndDt'}/>
												</FormHelperText>
											</FormControl>
										</Grid>
										{/*<Grid size={{ md: 6 }}>*/}
										{/*	<FormControl*/}
										{/*		{...formControlDefaults}*/}
										{/*		error={*/}
										{/*			formik.touched['EstimDt'] &&*/}
										{/*			Boolean(formik.errors['EstimDt'])*/}
										{/*		}*/}
										{/*	>*/}
										{/*		<FormLabel>{t('Est. Date')}</FormLabel>*/}
										{/*		<DatePicker*/}
										{/*			slotProps={{*/}
										{/*				textField: {*/}
										{/*					size: 'small',*/}
										{/*					variant: 'standard'*/}
										{/*				}*/}
										{/*			}}*/}
										{/*			name="EstimDt"*/}
										{/*			views={['year', 'month', 'day']}*/}
										{/*			inputFormat={dateFormat}*/}
										{/*			value={formik.values.EstimDt}*/}
										{/*			onChange={(newValue) => handleDate(newValue, 'EstimDt')}*/}
										{/*			onBlur={formik.handleBlur}*/}
										{/*		/>*/}
										{/*		<FormHelperText>*/}
										{/*			<ErrorMessage name={'EstimDt'}/>*/}
										{/*		</FormHelperText>*/}
										{/*	</FormControl>*/}
										{/*</Grid>*/}
										<Grid size={{ md: 10 }}>
											<FormControl
												{...formControlDefaults}
											>
												<FormLabel>{t('EstimCost')}</FormLabel>
												{/*<TextField*/}
												{/*	{...textFieldDefaults}*/}
												{/*	name={'EstimCost'}*/}
												{/*	value={formik.values.EstimCost}*/}
												{/*	onChange={formik.handleChange}*/}
												{/*	onBlur={formik.handleBlur}*/}
												{/*/>*/}
												
													<NumericFormat
														{...numericFormatDefaults}
														name={'EstimCost'}
														value={formik.values.EstimCost}
														onValueChange={(values, sourceInfo) => {
															formik.setFieldValue('EstimCost', values.floatValue ? values.floatValue : '')
														}}
														onBlur={formik.handleBlur}
													/>
												
												<FormHelperText>
													<ErrorMessage name={'EstimCost'}/>
												</FormHelperText>
											</FormControl>
										</Grid>
									</Grid>
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</PageContentWrapper>
				<Modal
					show={isDeletionVisible}
				>
					<Delete
						objectId={projectId}
						objectLabel={t('Project')}
						objectLabelValue={project?.Description}
						deletionUrl={`${API}/en/fts/project/remove`}
						redirectUrl={`/projects`}
						warningMessage={t('All data related to this project will be deleted!')}
						successMessage={t('Project deleted successfully!')}
						failureMessage={t('Unable to delete project!')}
						handleModal={handleDeletionModal}
						onClose={() => setIsDeletionVisible(false)}
					/>
				</Modal>
			</form>
		</FormikProvider>
	)
		;
};

export default Form